<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.DESCRIPTION' | translate }}
  </div>
  <div class="alert-wrapper">
    <glxy-alert type="tip">
      <div
        [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.ACTION.DISCLAIMER' | translate | iTrustThisHtml"
      ></div>
    </glxy-alert>
  </div>
  <form [formGroup]="form" class="time-of-activation">
    <div class="time-of-activation-label">
      {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.TIME_OF_ACTIVATION.LABEL' | translate }}
    </div>
    <mat-radio-group [formControl]="scheduleActivationControl">
      <mat-radio-button class="option" [value]="false">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.TIME_OF_ACTIVATION.ACTIVATE_NOW' | translate }}
      </mat-radio-button>
      <mat-radio-button class="option" [value]="true">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.TIME_OF_ACTIVATION.SCHEDULE_ACTIVATION' | translate }}
      </mat-radio-button>
      <mat-hint class="hint">
        {{ 'AUTOMATIONS.EDITOR.TASKS.ACTIVATE_SALES_ORDER.TIME_OF_ACTIVATION.HINT' | translate }}
      </mat-hint>
    </mat-radio-group>
  </form>
</div>
